import { BaseEntity } from './base-entity';

export class RiskFactorRank extends BaseEntity {
  numericValue: number;
  description: string;
}
